﻿import $ from "jquery";
import "bootstrap";
import "select2";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailAdbKonstenart extends GuiDetailGeneric {

    constructor() {
        super("AdbKostenart");
        this.setKostenTyp();

        $("select.tags").select2({
            tags: true,
            allowClear: true,
            placeholder: "",
            theme: "bootstrap-5",
            tokenSeparators: [",", " "]
        });
    }

    attachEvents(): void {
        super.attachEvents();
        $("#VmDetail_KostenartId").on("change", () => this.changeKostenart());
    }

    changeKostenart() {
        this.log("changeKostenart");

        this.setKostenTyp();
    }

    setKostenTyp() {
        this.log("setKostenTyp");

        const kostentyp = $("#VmDetail_KostenartId option:selected").data("data1");

        $("#spanErloese").addClass("d-none");
        $("#spanKosten").addClass("d-none");

        if (kostentyp === 1) {
            $("#spanKosten").removeClass("d-none");
        }

        if (kostentyp === -1) {
            $("#spanErloese").removeClass("d-none");
        }
    }
}
